/**
 * Created by anthony on 7/3/14.
 */


var extraQuestionsAnswers = angular.module('extraQuestionsAnswersModel', []);
extraQuestionsAnswers.factory('ExtraQuestionsAnswersModelFactory', function(ApplicationService, FamilyModelFactory){
    var ExtraQuestionsAnswers = function(familyID){
        this.familyID = familyID;
        this.dataProperty = "extraQuestionsAnswers";
        this.endpoint = "/ExtraQuestionsAnswers";
        this.primaryKey = "recordID";
    }
    ExtraQuestionsAnswers.prototype = new FamilyModelFactory();
    ExtraQuestionsAnswers.prototype.parent = FamilyModelFactory.prototype;
    return ExtraQuestionsAnswers;
});